import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AxiosError } from 'axios'

type SendFiscalNoteEmailParams = {
  fiscal_note_key: string
  to_address: string[]
  cc_addresses: string[]
}

export async function sendFiscalNoteEmail({
  fiscal_note_key,
  to_address,
  cc_addresses,
}: SendFiscalNoteEmailParams) {
  const response = await httpClient('accounting-dealer').post(
    `/v3/fiscal-note/${fiscal_note_key}/email`,
    {
      to_address,
      cc_addresses,
    },
  )

  return response.data
}

export function useSendFiscalNoteEmail(
  options?: Partial<
    UseMutationOptions<string, AxiosError, SendFiscalNoteEmailParams, unknown>
  >,
) {
  return useMutation({
    mutationFn: sendFiscalNoteEmail,
    ...options,
  })
}
